import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'
import type { ShiftType } from '../enums/ShiftType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class ShiftTemplateEntity {
  id?: string
  dayOfWeek?: DayOfWeek
  startTimeDate?: Date
  durationDate?: Date
  size?: number
  shiftType?: ShiftType
  region?: RegionMiniEntity
}
